import { render, staticRenderFns } from "./InfoPedido.vue?vue&type=template&id=82a52406&scoped=true&"
import script from "./InfoPedido.vue?vue&type=script&lang=js&"
export * from "./InfoPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a52406",
  null
  
)

export default component.exports